<template>
    <div id="sig-container" class="block full form-horizontal">
        <div class="loader" v-if="loading">
            <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <div class="widget">
        <div
            class="
            widget-content widget-content-mini
            themed-background-dark-default
            text-light
            "
        >
            <span class="float-right text-muted">
            <button
                type="button"
                @click="$router.go(-1)"
                class="btn btn-xs btn-primary"
            >
                Volver
            </button>
            </span>
            Informe contacto deudor
        </div>
        <div class="widget-content border-bottom themed-background-muted text-center">
            <div class="container">
                <div class="form-group">
                    <label class="control-label col-lg-3 col-md-2" v-text="'Telefono'"></label>
                    <div class="col-lg-12 col-md-12">
                        <input type="text" class="form-control" v-model="params.telefono"/>
                    </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-lg-3 col-md-2" v-text="'Email'"></label>
                        <div class="col-lg-12 col-md-12">
                            <input type="text" class="form-control" v-model="params.email"/>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button class="btn btn-primary" @click="index()">Aplicar</button>
                    </div>
                </div>
            </div>
        </div>
      <div>
        <div class="loader" v-if="loading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <table-component :data="datos">
          <table-column
            slot="label"
            :label="'Cedula'"
            v-bind:value="'identificacion'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Contacto deudor'"
            v-bind:value="'valor'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Nombre Deudor'"
            v-bind:value="'nombre'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Nit intermediario'"
            v-bind:value="'nit'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Nombre intermediario'"
            v-bind:value="'nombre_banco'"
          ></table-column>
        </table-component>
      </div>
    </div>
</template>

<script>
export default {
  name: "informe_contacto_deudor",
  data: () => {
    return {
      params: {
        telefono: "",
        email: "",
      },
      datos: [],
      loading: false
    }
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  methods: {
    async index() {
      if(this.params.telefono == "" && this.params.email == ""){
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content:
            "Es necesario diligenciar un campo para realizar la consulta",
        });
      }else if(this.params.telefono != "" && this.params.email != ""){
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content:
            "Solo puedes diligenciar uno de los campos para realizar la consulta",
        });
      }else{
        this.loading = true;
        await this.$store
          .dispatch("index", {
            endpoint: "informes/contacto-deudor",
            params: {
              telefono: this.params.telefono == "" ? null : this.params.telefono,
              email: this.params.email == "" ? null : this.params.email,
            }
          })
          .then((response) => {
            this.datos = response.datos;
            console.log('this.datos',this.datos)
            this.loading = false;
          })
          .catch((error) => {
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content: "Se ha presentado un error realizando su consulta",
            });
            this.loading = false;
          });

          this.params.telefono = "";
          this.params.email = "";
      }
    }
  }

}
</script>

<style>
</style>